'use strict';
/* globals $, window   */

var page = require('./modules/page-client')($, window);

window.BL.page = page;

$(function () {
	page.init();
});
